/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable react/jsx-no-duplicate-props */
import * as vp from 'vopay';
import { FunctionComponent } from 'react';
import { useHistory } from 'react-router-dom';
import SettingsCard from '../../UI/SettingsCard/SettingsCard';
import { usePermissions } from '../../../providers/Permissions.provider';
import { useLockedFeatureDialogue } from '../../../providers/LockedFeatureDialogue.provider';
import { useTranslation } from 'react-i18next';

const { Box, Title, SubTitle } = vp;
type FC = FunctionComponent;
const Settings: FC = () => {
  const history = useHistory();
  const { permissions } = usePermissions();
  const { updateIsLocked } = useLockedFeatureDialogue();
  const { t } = useTranslation('translations', { keyPrefix: 'Settings' });
  return (
    <div>
      <Box mb="md" jc="sb">
        <Title title={t('pageTitle')} />
      </Box>
      <Box flx="col">
        <SubTitle subTitle={t('Configuration.title')} />
        <Box mt="sm">
          <div>
            <SettingsCard
              Image="brandSettings"
              Title={t('Configuration.brandSettings')}
              isLocked={
                !permissions.WhitelabellingEnabled ||
                (!permissions.BrandingELinxEnabled &&
                  !permissions.BrandingEmailEnabled &&
                  !permissions.BrandingOnboardingEnabled &&
                  !permissions.BrandingPortalEnabled)
              }
              onClickDetails={() => {
                !permissions.WhitelabellingEnabled ||
                (!permissions.BrandingELinxEnabled &&
                  !permissions.BrandingEmailEnabled &&
                  !permissions.BrandingOnboardingEnabled &&
                  !permissions.BrandingPortalEnabled)
                  ? updateIsLocked(true, 'Branding')
                  : history.push('/settings/brand-settings');
              }}
            />
            <SettingsCard
              Image="webhooks"
              Title={t('Configuration.webhooks')}
              onClickDetails={() => {
                history.push('/settings/webhooks');
              }}
            />
          </div>
        </Box>
      </Box>
    </div>
  );
};
export default Settings;
